import { render, staticRenderFns } from "./ModelPerformance.vue?vue&type=template&id=2c2265f7&scoped=true&"
import script from "./ModelPerformance.vue?vue&type=script&lang=js&"
export * from "./ModelPerformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2265f7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/suspicious_login/suspicious_login/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c2265f7')) {
      api.createRecord('2c2265f7', component.options)
    } else {
      api.reload('2c2265f7', component.options)
    }
    module.hot.accept("./ModelPerformance.vue?vue&type=template&id=2c2265f7&scoped=true&", function () {
      api.rerender('2c2265f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ModelPerformance.vue"
export default component.exports